<template>
  <div class="panel pt-2">
    <div class="" v-if="crop_fields.length > 0">
      <apexchart
        type="line"
        height="450"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    crop_fields: {
      type: Array,
      required: true,
    },
    quality_attributes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    max_amplings: function () {
      let max = [];
      this.crop_fields.forEach((crop_field) => {
        max.push(crop_field.quality_inspects.max_sampling);
      });
      return Math.max(...max);
    },
    chartOptions: function () {
      return {
        chart: this.percent_chart_config,
        colors: [...this.attributes_colors, this.percent_color_line],
        stroke: {
          width: [...this.attributes_stroke_widths, this.percent_stroke.width],
        },
        xaxis: {
          type: "text",
          categories: this.crop_fields_codes,
        },
        yaxis: [...this.attributes_y_axis, this.percent_yaxis],
      };
    },
    series: function () {
      return [
        ...this.attributes_series,
        { name: "% de calidad", data: this.percent_data },
      ];
    },

    crop_fields_codes: function () {
      return this.crop_fields.map((crop_field) => {
        return crop_field.crop_field_code;
      });
    },

    // Percent line config
    percent_chart_config: function () {
      return {
        height: 350,
        type: "line",
        zoom: {
          enabled: true,
        },
      };
    },
    percent_color_line: function () {
      return "#38B61E";
    },
    percent_data: function () {
      return this.crop_fields.map((crop_field) => {
        return crop_field.quality_inspects.quality_accepted_percent;
      });
    },
    percent_stroke: function () {
      return {
        width: 4,
      };
    },
    percent_yaxis: function () {
      return {
        // min: this.getMinValueToCropFields() / 2,
        // max: Math.max(this.getMaxValueToCropFields(), 100) + 5,
        min: 0,
        max: 100,
        title: {
          text: "% de calidad",
          style: {
            fontSize: "14px",
          },
        },
        labels: {
          formatter: function (val) {
            return parseInt(val * 100) / 100;
          },
        },
      };
    },

    // attributes config
    attributes_chart_config: function () {
      return this.quality_attributes.map(() => {
        return {
          height: 350,
          type: "column",
        };
      });
    },
    attributes_colors: function () {
      return this.quality_attributes.map(() => {
        return "#DC2626";
      });
    },
    attributes_series: function () {
      return this.quality_attributes.map(
        (quality_attribute) => {
          return {
            name: quality_attribute.crop_attribute.name,
            type: "column",
            data: this.getAttributeValues(quality_attribute),
          };
        }
      );
    },
    attributes_stroke_widths: function () {
      return this.quality_attributes.map(() => {
        return 1;
      });
    },
    attributes_y_axis: function () {
      return this.quality_attributes.map(
        (quality_attribute) => {
          return {
            opposite: true,
            title: {
              text: quality_attribute.crop_attribute.name,
              style: {
                fontSize: "14px",
              },
            },
            labels: {
              formatter: function (val) {
                return parseInt(val);
              },
            },
            // show: this.chartOptions.yaxis.length === 0,
            min: 0,
            max: this.max_amplings * 2,
          };
        }
      );
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    getAttributeValues: function (attribute) {
      let attrs = this.crop_fields.map((crop_field) => {
        return crop_field.quality_inspects.quality_generals.find(
          (attr) => attr.quality_attribute_id == attribute.id
        );
      });
      return attrs.map((attr) => attr.value_float);
    },
    getMinValueToCropFields: function () {
      return Math.min(...this.percent_data) || 0;
    },
    getMaxValueToCropFields: function () {
      return Math.max(...this.percent_data);
    },
  },
};
</script>
